angular.module('app.admin.videoAnalysis.videoAnalysisController', [])
  .controller(
    'app.admin.videoAnalysis.videoAnalysisController', [
      '$scope',
      '$transitions',
      function ($scope, $transitions) {
        "use strict";

        $scope.filterData = {
          filters: {},
          labels: {},
          preset: null
        };

        $scope.filterCleared = false; // determines when user clears filters on my clips view

        $scope.cachedFilterData = {};

        $transitions.onStart({},
          ($transition) => {
            let toState = $transition.$to();
            let fromState = $transition.$from();

            let params = $transition.params();

            if (toState.name === 'app.admin.videoAnalysis.filterForm') {
              if (!angular.equals({}, $scope.filterData.filters)) {
                $scope.cachedFilterData.filters = $scope.cachedFilterData.hasOwnProperty('filters')
                  ? $scope.cachedFilterData.filters : JSON.stringify($scope.filterData.filters);

                $scope.cachedFilterData.preset = $scope.cachedFilterData.hasOwnProperty('preset')
                  ? $scope.cachedFilterData.preset : null;

              } else {
                if ($scope.cachedFilterData.hasOwnProperty('filters')
                  && !angular.equals({}, $scope.cachedFilterData.filters) && !$scope.filterCleared) {

                  //toState.params.filter = $scope.cachedFilterData.filters;
                } else {
                  $scope.cachedFilterData.filters = JSON.stringify(angular.copy($scope.filterData.filters));
                  $scope.cachedFilterData.preset = JSON.stringify(angular.copy($scope.filterData.preset));
                  //toState.params.filter = $scope.cachedFilterData.filters;

                  if ($scope.filterCleared) {
                    $scope.filterCleared = false;
                  }
                }
              }
            }

            if (fromState.name === 'app.admin.videoAnalysis.filterForm'
              && params
              && angular.isDefined(params.filter)) {

              if (params.submitted) {
                $scope.filterData.filters = params.filter;
                $scope.filterData.preset = params.preset;

                $scope.cachedFilterData = angular.copy($scope.filterData);
              } else {
                $scope.cachedFilterData.filters = params.filter;
                $scope.cachedFilterData.preset = params.preset;
              }
            }
          }
        );
      }
    ]
  );


// WEBPACK FOOTER //
// ./app.v2/components/admin/videoAnalysis/videoAnalysisController.js